import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SidebarModule } from 'src/app/common/components/navbar/sidebar/sidebar.module';
import { TopbarModule } from 'src/app/common/components/navbar/topbar/topbar.module';



@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    TopbarModule,
    SidebarModule,
  ],
  exports: [
    DashboardComponent
  ]
})

export class DashboardModule { }